import { render, staticRenderFns } from "./UserLogInfo.vue?vue&type=template&id=2faff31e&"
import script from "./UserLogInfo.vue?vue&type=script&lang=js&"
export * from "./UserLogInfo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports